import React, { useState, useEffect } from 'react';
import { Grid, Typography, Button } from '@material-ui/core';

// components
import { useHistory } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import TableData from '../../components/TableData';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import useStyles from './styles';
import api from '../../services/api';
import { getError } from '../../utils/getResponseError';
import { dateWithHours, parseISO } from '../../utils/dateFormatter';

export default function Logs() {
  const history = useHistory();
  const classes = useStyles();
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState(null);
  const layoutDispatch = useLayoutDispatch();

  useEffect(() => {
    logsRequest();
  }, [page]);

  async function logsRequest() {
    toggleLoading(layoutDispatch);
    setError(null);
    try {
      const { data } = await api.get(`/logs?pagina=${page}`);
      setTotal(data.totalPaginas);
      setJobs(data.dados.map((item) => ({
        ...item,
        criado_em: dateWithHours(parseISO(item.criado_em)),
        nomeUsuario: item.Usuario.nome,
        emailUsuario: item.Usuario.email
      })));

      if (page > data.totalPaginas) {
        setPage(1);
      }
    } catch (error) {
      setError(getError(error));
    }
    toggleLoading(layoutDispatch);
  }

  function handlePage(newPage) {
    if (newPage !== page) {
      setPage(newPage);
    }
  }

  function handleReload() {
    logsRequest();
  }

  return (
    <>
      <PageTitle
        title="Logs de acesso"
      />
      {error && (
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}

          >
            <Widget
              disableWidgetMenu
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h6"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Ocorreu um erro ao tentar listar os registros de acesso
              </Typography>
              <Typography
                variant="p"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Mensagem de erro:
                {' '}
                {error}
              </Typography>
              <br />
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginTop: 50
                }}
                onClick={handleReload}
              >
                Tentar novamente
              </Button>
            </Widget>
          </Grid>
        </Grid>
      )}
      {!error && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TableData
              title="Logs de acesso"
              columns={[{
                name: 'nomeUsuario',
                label: 'Nome do usuário',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                name: 'emailUsuario',
                label: 'Email',
                options: {
                  filter: true,
                  sort: false,
                }
              },
              {
                name: 'criado_em',
                label: 'Data e hora',
                options: {
                  filter: true,
                  sort: false,
                }
              }]}
              data={jobs}
              page={page}
              total={total}
              onSetPage={handlePage}
              hideOptions
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
